import React, { useState } from 'react';
import { axiosInstance } from '../lib/axio';
import "../styles/newsletter.css";

function Newsletter() {
    const [email, setEmail] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false); // Track if the email is submitted
    const [errorMessage, setErrorMessage] = useState(''); // Track error message for invalid email

    function isValidEmail(email) {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!isValidEmail(email)) {
            setErrorMessage('Please enter a valid email address.');
            setTimeout(() => setErrorMessage(''), 3000); // Clear error message after 3 seconds
            return;
        }

        try {
            setIsSubmitted(true); // Set the submission state to true
            setEmail(''); // Clear the email input
            setErrorMessage(''); // Clear any previous error message
            await axiosInstance.post('/send-welcome-email', { email });
        } catch (error) {
            console.error('Error sending email:', error);
        }
    };

    return (
        <div className="bg-creamColor flex items-center justify-center">
            <div className="newsletter-container relative p-6 rounded-lg shadow-md w-[92%] h-[85vh] flex flex-col items-center justify-center bg-[url('https://www.batsfordbooks.com/wp-content/uploads/2024/02/Celtic-blog-post-introduction-banner--1024x478.jpg')] bg-cover bg-center">
                {/* Darken overlay */}
                <div className="absolute inset-0 bg-black opacity-50"></div>

                {isSubmitted ? (
                    <div className="text-center z-50">
                        <h2 className="text-[38px] font-semibold text-white poppins-medium">Thank You!</h2>
                        <p className="text-white mt-4 text-[16px] poppins-light">
                            You have successfully signed up for our newsletter. Stay tuned for updates!
                        </p>
                    </div>
                ) : (
                    <>
                        <h2 className="newsletter-header poppins-medium text-white">Get the low-down.</h2>
                        <p className="newsletter-para poppins-light text-white">
                            Sign up with your email address to receive news and updates.
                        </p>
                        <form onSubmit={handleSubmit} className="w-[40%] z-50 newsletter-form">
                            <div className="mb-6 flex justify-evenly newsletter-form-div">
                                <input
                                    type="email"
                                    id="email"
                                    className="w-[300px] h-[65px] px-3 py-2 border focus:outline-none focus:ring-2 focus:ring-white"
                                    placeholder="Email Address"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    disabled={isSubmitted} // Disable input after submission
                                />
                                <button
                                    type="submit"
                                    className={`bg-[#F08E80] hover: text-white poppins-medium font-bold py-2 px-8 transition-opacity duration-150 delay-75 ease-in-out ${
                                        isSubmitted ? 'opacity-50 cursor-not-allowed' : ''
                                    }`}
                                    disabled={isSubmitted} // Disable button after submission
                                >
                                    {isSubmitted ? 'Signed Up' : 'Sign Up'}
                                </button>
                            </div>
                            {errorMessage && (
                                <div className="bg-red-500 text-white p-3 rounded-lg mt-4 shadow-lg animate-fade-in-out">
                                    <p className="text-center font-semibold">{errorMessage}</p>
                                </div>
                            )}
                        </form>
                    </>
                )}
            </div>
        </div>
    );
}

export default Newsletter;
